import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import socket from "../../services/socket";
import { getParams, getStatusbarHeight } from "../../tool";
import styles from "./index.module.css";

export default function Main(props) {
  const shrink = getParams("shrink");
  const pathArr = ['/', '/sale', '/order', '/mine', '/member', "/score"] //一级路由
  const [position, setPosition] = useState({
    startX: 0,
    startY: 0,
    moveX: 0,
    moveY: 0,
  });
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const timer = useRef(null);

  const onTouchStart = (e) => {
    if (!pathArr.includes(pathname)) {
      setPosition({
        ...position,
        ...{ startX: e.touches[0].pageX, startY: e.touches[0].pageY },
      });
    }
  };
  const onTouchMove = (e) => {
    setPosition({
      ...position,
      ...{ moveX: e.touches[0].pageX, moveY: e.touches[0].pageY },
    });
  };

  const onTouchEnd = () => {
    clearTimeout(timer.current);
    const x = position.moveX - position.startX;
    const y = position.moveY - position.startY;
    if (!pathArr.includes(pathname)) {
      if (Math.abs(x) > Math.abs(y) && position.startX < 30 && x > 50) {
        timer.current = setTimeout(() => {
          navigate(-1);
        }, 0);
      }
    }
  };

  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname !== "/cusService" &&
      location.pathname !== "/cusChat"
    ) {
      socket.close();
    }
  }, [location.pathname]);

  return (
    <div
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      className={`${styles.main} ${props.className || ""}`}
      style={{
        paddingTop: `${getStatusbarHeight() + shrink ? getStatusbarHeight() + shrink : 0
          }px`,
      }}
    >
      {props.children}
    </div>
  );
}
